import { Checkbox } from "@material-ui/core";
import React from "react";
import TextNumberInput from "./TextNumberInput";

export default class InserimentoMultiploWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      lunedi: false,
      martedi: false,
      mercoledi: false,
      giovedi: false,
      venerdi: false,
      sabato: false,
      domenica: false,
      numGiorni: 1,
    };
  }
  getValues() {
    return {
      ripetizioni: parseInt(this.state.numGiorni) || 0,
      giorniSettimana: [
        this.state.lunedi,
        this.state.martedi,
        this.state.mercoledi,
        this.state.giovedi,
        this.state.venerdi,
        this.state.sabato,
        this.state.domenica,
      ],
    };
  }

  render() {
    return (
      <div>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            this.setState({ visible: !this.state.visible });
          }}
        >
          Inserimento multiplo: ᐁ
        </div>{" "}
        <div style={{ display: this.state.visible ? "block" : "none" }}>
          <Checkbox
            checked={this.state.lunedi}
            onClick={() => {
              this.setState({ lunedi: !this.state.lunedi });
            }}
          />
          Lun
          <Checkbox
            checked={this.state.martedi}
            onClick={() => {
              this.setState({ martedi: !this.state.martedi });
            }}
          />
          Mar
          <Checkbox
            checked={this.state.mercoledi}
            onClick={() => {
              this.setState({ mercoledi: !this.state.mercoledi });
            }}
          />
          Mer
          <Checkbox
            checked={this.state.giovedi}
            onClick={() => {
              this.setState({ giovedi: !this.state.giovedi });
            }}
          />
          Gio
          <br />
          <Checkbox
            checked={this.state.venerdi}
            onClick={() => {
              this.setState({ venerdi: !this.state.venerdi });
            }}
          />
          Ven
          <Checkbox
            checked={this.state.sabato}
            onClick={() => {
              this.setState({ sabato: !this.state.sabato });
            }}
          />
          Sab
          <Checkbox
            checked={this.state.domenica}
            onClick={() => {
              this.setState({ domenica: !this.state.domenica });
            }}
          />
          Dom
          <br />{" "}
          <TextNumberInput
            name={"Settimane totali:"}
            value={this.state.numGiorni}
            minValue="1"
            placeholder="1 = solo questa settimana"
            onChange={(val) => this.setState({ numGiorni: val })}
          />
          <div style={{ fontSize: "12px", color: "#666", marginTop: "5px" }}>
            Seleziona i giorni della settimana e il numero di settimane:
            <br />
            • 1 = lezioni solo in questa settimana
            <br />
            • 2 = questa settimana + 1 ripetizione (2 settimane totali)
            <br />• 3 = questa settimana + 2 ripetizioni (3 settimane totali)
          </div>
        </div>
      </div>
    );
  }
}
